export default __webpack_public_path__ + "./images/sk.c474e52a.png";